var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSngls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32805)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#B30D23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.51356 11.9441L8.98931 12.9206L8.46506 11.9441C5.29819 11.6983 2.8125 9.33694 2.8125 9.33694C2.8125 9.33131 5.22787 7.04306 8.33006 6.74156L8.74069 6.03844L8.98931 5.625L9.41119 6.32812L9.64856 6.74156C12.7502 7.03744 15.1661 9.33694 15.1661 9.33694C15.1661 9.33694 12.6804 11.6983 9.51356 11.9441ZM3.33675 9.33694C3.33113 9.33694 5.72513 10.9727 8.12981 11.3186L6.95756 9.12488L7.27594 8.5725L7.56844 9.11925L7.56281 9.12488L8.703 11.3692C8.79469 11.3749 8.88637 11.3749 8.97862 11.3749C9.07031 11.3749 9.15694 11.3749 9.24862 11.3692L10.0862 9.69975L10.6971 8.56125L11.0154 9.11362L9.84319 11.313C12.2479 10.9727 14.6413 9.37631 14.6413 9.33131C14.6413 9.29194 12.3615 7.76869 10.0159 7.37775L10.3725 7.99763L10.0755 8.59444L9.30263 7.29956C9.19831 7.29303 9.09383 7.28928 8.98931 7.28831C8.88637 7.28831 8.77837 7.29394 8.67037 7.29956L7.88119 8.59444L7.58981 8.02519L7.96219 7.38338C5.61712 7.77994 3.33675 9.33694 3.33675 9.33694Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32805"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSngls);
export default __webpack_public_path__ + "static/media/sngls.be428ebff0e535c6bbf5aace7fb2e20a.svg";
export { ForwardRef as ReactComponent };